"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BrowserUtil = /** @class */ (function () {
    function BrowserUtil() {
    }
    /**
     * Return true if the code is run in a Browser Environment
     */
    BrowserUtil.isBrowser = function () {
        return typeof window !== 'undefined';
    };
    BrowserUtil.getHref = function () {
        return BrowserUtil.isBrowser() && window.location ? window.location.href : '';
    };
    BrowserUtil.getPath = function () {
        return BrowserUtil.isBrowser() && window.location ? window.location.pathname : '';
    };
    BrowserUtil.getHost = function () {
        return BrowserUtil.isBrowser() && window.location ? window.location.hostname : '';
    };
    BrowserUtil.getSearch = function () {
        return BrowserUtil.isBrowser() && window.location ? window.location.search : '';
    };
    BrowserUtil.getProtocol = function () {
        return BrowserUtil.isBrowser() && window.location ? window.location.protocol : '';
    };
    BrowserUtil.getOrigin = function () {
        //TODO test removal of lines to init origin. In TS, origin is readonly
        // if (!window.location.origin) {
        //   window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
        // }
        if (BrowserUtil.isBrowser() && window.location) {
            var origin_1 = window.location.origin;
            if (!origin_1) {
                return (window.location.protocol +
                    '//' +
                    window.location.hostname +
                    (window.location.port ? ':' + window.location.port : ''));
            }
            return origin_1;
        }
        return '';
    };
    return BrowserUtil;
}());
exports.default = BrowserUtil;
//# sourceMappingURL=BrowserUtil.js.map